import { Input } from '@nextui-org/react'
import { FC } from 'react'
import { MdOutlineSearch } from 'react-icons/md'

interface Props {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  className?: string
}

/** Buscador estándar del módulo (estilo NextUI), igual que en HomePage. */
const LogiSearch: FC<Props> = ({ value, onChange, placeholder = 'Buscar…', className = 'max-w-sm' }) => (
  <div className={className}>
    <Input
      isClearable
      radius='lg'
      value={value}
      onValueChange={onChange}
      onClear={() => onChange('')}
      classNames={{
        input: ['bg-transparent', 'text-black/90', 'placeholder:text-default-700/50'],
        innerWrapper: 'bg-transparent',
        inputWrapper: ['bg-default-200/50', 'backdrop-blur-xl', 'backdrop-saturate-200', 'hover:bg-default-200/70', 'group-data-[focus=true]:bg-default-200/50', '!cursor-text']
      }}
      placeholder={placeholder}
      startContent={<MdOutlineSearch className='text-black/50 mb-0.5 text-slate-400 pointer-events-none flex-shrink-0' />}
    />
  </div>
)

export default LogiSearch
